export default "__VITE_ASSET__BntiqxMc__"